import { TitleCasePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { PaymentRequestStatusEnum } from '../payment-request-status.enum';

@Component({
  selector: 'pioneer-payment-action-complete',
  templateUrl: './payment-action-complete.component.html',
})
export class PaymentActionCompleteComponent implements OnInit {

  @Input() form: FormGroup;

  cardHeader: string;
  datetime: Date;
  actionBy: string;

  constructor(
    private translate: TranslateService,
    private titleCasePipe: TitleCasePipe
  ) { }

  ngOnInit() {
    this.datetime = new Date();

    if (this.reason) {
      this.cardHeader = this.translate.instant('EVENT.COMMISSION.REJECTION_REASONS_HEADER');
      this.actionBy = this.titleCasePipe.transform(PaymentRequestStatusEnum.REJECTED.toString());
    } else {
      this.cardHeader = this.translate.instant('EVENT.COMMISSION.PAYMENT_CONFIRMED');
      this.actionBy = this.titleCasePipe.transform(PaymentRequestStatusEnum.APPROVED.toString());
    }
  }

  get email() { return this.form.get('email'); }
  get reason() { return this.form.get('reason'); }
  get description() { return this.form.get('description'); }
  get details() { return this.form.get('details'); }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-action-complete/payment-action-complete.component.ts